module.exports = __webpack_public_path__ + "img/female6.716bb308.jpeg";